module.exports = __webpack_public_path__ + "static/media/check-remaining-traffic_3.ae442781.png";